import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

import Panel from './Panel'
import SmartRateRow from './SmartRateRow'

const Container = styled.div`
  margin-top: 20px;
`
const RowContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px;
`
const Header = styled.div`
  display: grid;
  grid-template-columns: .2fr 1fr 1fr 1fr;
  margin-bottom: 5px;
  padding: 10px 0px;
`
const HeaderCell = styled.div`
  display: flex;
  align-items: center;
  justify-self: center;
  justify-content: center;
  font-size: 16px;
`
const QuestionMark = styled.i`
  background: white;
  color: #999c9d;
  position: relative;
  &:hover {
    cursor: default;
  }
`
const ToolTip = styled.div`
  font-family: 'Open Sans', sans-serif;
  background: #7f8284;
  color: white;
  display: none;
  ${QuestionMark}:hover & {
    display: block;
  }
  border-radius: 5px;
  padding: 10px;
  position: absolute;
  text-align: center;
  bottom: 25px;
  width: 290px;
  left: -145px;
  &::after {
    position: absolute;
    bottom: -6px;
    content: '';
    width: 0;
    height: 0;
    border-left: 7px solid transparent;
    border-right: 7px solid transparent;
    border-top: 7px solid #7f8284;
    left: 0;
    right: 0;
    margin: auto 0;
    left: calc(50% - 10px);
  }
`

export default class SmartRateHistory extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showAll: false
    }
  }
  static propTypes = {
    predictionResults: PropTypes.arrayOf(PropTypes.object)
  }
  onShowToggle = () => {
    this.setState({ showAll: !this.state.showAll })
  }
  renderPredictionResults = () => {
    const { predictionResults } = this.props
    const { showAll } = this.state
    if (!showAll) {
      const [result] = predictionResults
      return <SmartRateRow key={result.id} predictionResult={result} />
    } else {
      return predictionResults.map(result => <SmartRateRow key={result.id} predictionResult={result} />)
    }
  }
  render() {
    const { predictionResults } = this.props
    const { showAll } = this.state
    if (predictionResults.length > 0) {
      return (
        <Container>
          <Panel title="SmartRate History" onClick={predictionResults.length > 1 ? this.onShowToggle : null} onClickText={showAll ? 'Hide All' : 'Show All'}>
            <RowContainer>
              <Header>
                <HeaderCell />
                <HeaderCell>
                  Source Data
                  <QuestionMark className="fa fa-question-circle">
                    <ToolTip>
                      We use the source data to calculate the SmartRate. The more data we have, the more accurate the SmartRate gets. The dots (&bull;) on the loan
                      and pipeline view represent the number of data sources we currently have to calculate the SmartRate.
                    </ToolTip>
                  </QuestionMark>
                </HeaderCell>
                <HeaderCell>
                  SmartRate
                </HeaderCell>
                <HeaderCell>
                  Model Date
                </HeaderCell>
              </Header>
              {this.renderPredictionResults()}
            </RowContainer>
          </Panel>
        </Container>
      )
    } else {
      return null // Show nothing if there is no Smart Rate history
    }
  }
}
